import { connect } from 'react-redux';
import _merge from 'lodash.merge';
import Player from './player.component';
import * as MediaPlayerActions from './player.actions';
import { getSecondsFromTimeString } from '@medscape-promo/medscapetv/utils/time-converter';

const mapStateToProps = (state, ownProps) => {
    let config = _merge({},ownProps.config);
    let { controls } = config;
    delete config.controls;
    const props = {
        config: _merge({}, config, {
            "duration": getSecondsFromTimeString(ownProps.config.duration),
            "plugins": {
                "TrackingPixels": typeof ownProps["tracking-pixels"] === 'undefined' ? null : ownProps["tracking-pixels"]
            }
        }),
        controls
    }

    return props;
};
const mapDispatchToProps = dispatch => {
    return {
        onReady: (media, containerEl) => {
            dispatch(MediaPlayerActions.createPlayer(media, containerEl));
        },
        onUpdate: (media) => {
            dispatch(MediaPlayerActions.setMedia(media));
        },
        onDestroy: (player) => {
            dispatch(MediaPlayerActions.destroyPlayer());
        }
    }
};

const PlayerModule = connect(mapStateToProps, mapDispatchToProps)(Player);
export default PlayerModule;